import React, { useRef, useCallback } from 'react';
import {
	HeaderTop,
	LoadingBlock,
	NoDataContainer,
	SectionWrapper,
	Title,
} from './SkuStackedBarChart.styles';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {
	ApButtonIcon,
	ApLoaderDefault,
	ApLoaderText,
	ApMenu,
	ApMenuItem,
	colors,
} from '@alixpartners/ui-components';

const EXPORT_OPTIONS = [
	{
		label: 'Export chart as image',
		value: 'png',
	},
];
export const DualSourcedSkuProfileChart = ({ options, data, isLoading }) => {
	const chartRef = useRef(null);

	const handleExportImage = useCallback(() => {
		if (chartRef.current && chartRef.current.chart) {
			const chart = chartRef.current.chart;
			chart.exportChart(
				{
					type: 'image/png',
					filename: 'SXR-Dual_sourced_sku_profile',
				},
				{
					chart: {
						width: 1200,
					},
					title: {
						text:
							'<div style="text-align:center; width:100%; ">Dual Sourced SKU Profile</div>',
						useHTML: true,
						floating: true,
						style: {
							color: colors.grey5,
							fontSize: '13px',
						},
						y: 2,
					},
				}
			);
		} else {
			console.warn('Chart instance not yet available for export.');
		}
	}, []);

	const getChartInstance = () => {
		return chartRef && chartRef.current && chartRef.current.chart;
	};

	return (
		<SectionWrapper>
			<HeaderTop>
				<Title>Dual Sourced SKU Profile</Title>
				{!isLoading && (
					<ApMenu button={<ApButtonIcon iconName="download" />}>
						{EXPORT_OPTIONS.map(option => (
							<ApMenuItem
								key={option.value}
								onClick={() => {
									if (option.value === 'png') {
										handleExportImage(
											getChartInstance(),
											'SXR-Dual_sourced_sku_profile'
										);
									}
								}}
							>
								{option.label}
							</ApMenuItem>
						))}
					</ApMenu>
				)}
			</HeaderTop>
			{isLoading ? (
				<LoadingBlock>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingBlock>
			) : (
				<>
					{data.categories.length > 0 ? (
						<HighchartsReact
							highcharts={Highcharts}
							options={options}
							ref={chartRef}
						/>
					) : (
						<NoDataContainer>No data available</NoDataContainer>
					)}
				</>
			)}
		</SectionWrapper>
	);
};
